import React from 'react';
import {
    Page,
    Autocomplete,
    Stack,
    Tag,
    Layout,
    Card,
    Select,
    FormLayout,
    TextField,
    Icon,
    Button
} from '@shopify/polaris';
import {
    SearchMinor
} from '@shopify/polaris-icons';
import { mapToFilter, apiFetch as fetch } from '../common/Helpers';
import ProductConditionsComponent from '../components/ProductConditionsComponent';
import { Helmet } from 'react-helmet';

const RuleTypes = [
    { value: 'OneOf', label: 'One of (only one of the selected tags must be present)' },
    { value: 'AnyOf', label: 'Any of (any of the selected can be present)' },
    { value: 'AllOf', label: 'All Of (all of the selected tags must be present)' }
]

class TagValidationComponent extends React.Component {

    state = {
        name: null,
        availableTags: [],
        matchingTags: [],
        rule: {
            tagList: [],
            type: "OneOf",
        },
        inputValue: '',
        precondition: null,
        errors: [],
        selectedOptions: [],
        errorName: null,
        errorTagList: null,
    };

    constructor(props) {
        super(props)

        if (props.validation != null) {
            if (props.validation.name != null) {
                this.state.name = props.validation.name;
            }

            if (props.validation.rule != null) {
                this.state.rule = props.validation.rule;
            }

            if (props.validation.precondition != null) {
                this.state.precondition = props.validation.precondition;
            }
        }
    }

    handleTagSelected = (selected) => {
        if (selected.length <= 0) {
            return;
        }

        var selectedTag = selected[0];
        var selectedIndex = this.state.rule.tagList.findIndex(tag => tag === selectedTag);
        var rule = this.state.rule;

        if (selectedIndex >= 0) {
            rule.tagList = [...this.state.rule.tagList.slice(0, selectedIndex), ...this.state.rule.tagList.slice(selectedIndex + 1)];
        }
        else {

            rule.tagList = [...this.state.rule.tagList, selectedTag];
        }

        this.setState({
            rule: rule,
            inputValue: selectedTag
        });
    }

    handleTagClicked = (tag) => {
        this.handleTagSelected([tag]);
    }

    updateText = (value) => {
        this.setState({ inputValue: value });

        if (value === '') {
            this.setState({
                matchingTags: this.state.availableTags.map((item, index) => {
                    return {
                        label: item,
                        value: item,
                    }
                }
                )
            });
            return;
        }

        const filterRegex = new RegExp(value, 'i');
        const resultOptions = this.state.availableTags.filter((option) => {
            return option.match(filterRegex)
        });

        this.setState({
            matchingTags: resultOptions.map((item, index) => {
                return {
                    label: item,
                    value: item,
                }
            }
            )
        });
    }

    render() {

        const textField = (
            <Autocomplete.TextField
                onChange={this.updateText}
                error={this.state.errorTagList}
                label="Tags"
                value={this.state.inputValue}
                prefix={<Icon source={SearchMinor} color="inkLighter" />}
                placeholder="Search"
            />
        );


        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Create Validation</title>
                </Helmet>
                <Page
                    // narrowWidth
                    title="Validations"
                    primaryAction={{ content: 'Save', onAction: this.handleSave }}
                    secondaryActions={[
                        {
                            content: 'Delete',
                            destructive: true,
                            onAction: this.handleDelete
                        },
                    ]}
                    breadcrumbs={[{ content: 'Create Validation', url: '/validations' }]}
                >
                    <Layout.AnnotatedSection
                        title="Validation name"
                        description="Try a name that suggests what this validation is about. For example, 'Clothing size is specified' is a great name for a validation that checks if size tags are applied to products."
                    >
                        <Card sectioned>
                            <FormLayout>
                                <TextField
                                    label="Validation name"
                                    value={this.state.name}
                                    error={this.state.errorName}
                                    onChange={this.handleNameChange} />
                            </FormLayout>
                        </Card>
                    </Layout.AnnotatedSection>
                    <Layout.AnnotatedSection
                        title="Validation Rule"
                        description="The rule specifies the list of tags that must be validated and how they are validated.">
                        <Card sectioned>
                            <FormLayout>
                                <Select
                                    options={RuleTypes}
                                    value={this.state.rule.type}
                                    onChange={(selected, id) => this.handleRuleTypeChange(selected)}>
                                </Select>
                                <Autocomplete
                                    options={this.state.matchingTags}
                                    selected={this.state.rule.tagList}
                                    onSelect={this.handleTagSelected}
                                    textField={textField}
                                />
                                <Stack>
                                    {this.state.rule.tagList.map(item => <Tag onClick={() => { this.handleTagClicked(item); }}>{item}</Tag>)}
                                </Stack>
                            </FormLayout>
                        </Card>
                    </Layout.AnnotatedSection>
                    <Layout.AnnotatedSection
                        title="Precondition"
                        description="Preconditions allows you to restrict the products that a validation is performed on. For example, you can create a precondition to include product from a certain vendor only.">
                        <Card sectioned>
                            <div>
                                <Button onClick={this.handleTogglePrecondition}>{this.state.precondition == null ? "Enable precondition" : "Disable precondition"}</Button>
                            </div>
                            {this.state.precondition != null && <ProductConditionsComponent
                                variants={this.state.variants}
                                selectedOptions={this.state.selectedOptions}
                                tags={this.state.availableTags}
                                filters={[this.state.precondition]}
                                onValueChange={this.handleValueChange}
                                onOperatorChange={this.handleOperatorChange}
                                onFilterTypeChange={this.handleFilterTypeChange} />}
                        </Card>
                    </Layout.AnnotatedSection>
                </Page>
            </div>
        );
    }

    handleSave = async () => {
        const isValid = this.validateValidation();

        if (!isValid) {
            return;
        }

        const mappedFilters = this.state.precondition == null ? null : mapToFilter(this.state.precondition);
        const precondition = mappedFilters == null ? null : {
            filterType: "composite",
            logicalOperator: "And",
            children: [mappedFilters]
        }

        await this.props.onSave({
            name: this.state.name,
            precondition: precondition,
            rule: this.state.rule
        });
    }

    handleDelete = async () => {
        this.props.onDelete();
    }

    handleOperatorChange = (item, newValue) => {
        item.operator = newValue;

        // TODO: Fix this
        // this.validate(this.state.action, this.state.productFilters);

        // TODO: fix this hack
        this.setState({
            precondition: this.state.precondition
        });
    }

    handleFilterTypeChange = (item, newValue) => {
        item.filterType = newValue;

        item.operator = "EqualTo"
        // TODO: Fix this

        // TODO: fix this hack
        this.setState({
            precondition: this.state.precondition
        });
    }

    handleValueChange = (item, newValue) => {
        item.value = newValue;

        // TODO: fix this hack
        this.setState({
            precondition: this.state.precondition
        });
    }

    handleTogglePrecondition = (newValue) => {
        if (this.state.precondition == null) {

            this.setState({
                precondition: {
                    "filterType": "ProductNameFilter",
                    "field": "Name",
                    "operator": "EqualTo",
                    "value": ""
                }
            });
        }
        else {
            this.setState({ precondition: null });
        }
    }

    handleNameChange = (newValue) => {
        this.setState({ name: newValue });
    }

    handleRuleTypeChange = (newValue) => {
        var rule = this.state.rule;
        rule.type = newValue;
        this.setState({ rule: rule });
    }

    validateValidation = () => {
        let hasError = false;

        if (this.state.name == null) {
            this.setState({ errorName: "Name is required" });
            hasError = true;
        }
        else {
            this.setState({ errorName: null });
        }

        if (this.state.rule.tagList.length === 0) {
            this.setState({ errorTagList: "Tag least one tag is required" });
            hasError = true;

        }
        else {
            this.setState({ errorTagList: null });
        }

        return !hasError;
    }

    componentDidMount() {
        // TODO: update this with new calls
        fetch(`api/products/tags`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                availableTags: data, matchingTags: data.map((item, index) => {
                    return {
                        label: item,
                        value: item,
                    }
                }
                )
            }));

        fetch(`api/products/selected-options`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({ selectedOptions: data }));
    }

    r
}

export default TagValidationComponent;